import React from 'react';
import { COLORS } from '@bcm/constants';
import { StyleSheet } from 'react-native';

import GlobalPressable from '../button/GlobalPressable';
import Icon from '../icon/Icon';
import IconMap from '../icon/IconMap';

const HeaderLeft = ({ onPress }) => (
	<GlobalPressable
		onPress={onPress}
		style={styles.headerLeftContainer}
	>
		<Icon
			icon={IconMap.back}
			color={COLORS.white}
			size={26}
		/>
	</GlobalPressable>
);

const styles = StyleSheet.create({
	headerLeftContainer: {
		marginLeft: 16,
	},
});

export default HeaderLeft;